import React from 'react';
import { Card, CardBody } from 'reactstrap';
import * as Yup from 'yup';
import { useNavigate } from 'react-router-dom';

import { Formik } from 'formik';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import UpdatePasswordForm from './components/UpdatePasswordForm';
import { UPDATE_PASSWORD } from './UpdatePasswordGraphQL';

const validationSchema = Yup.object({
  oldPassword: Yup.string()
    .min(6, 'Password must contain at least 6 characters')
    .required('This field is required'),
  newPassword: Yup.string()
    .required('This field is required')
    .matches(
      /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/,
      'Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character',
    ),
});

const initialValues = {
  oldPassword: '',
  newPassword: '',
};

const UpdatePassword = () => {
  const navigate = useNavigate();
  // UpdatePassword mutation
  const [updatePassword] = useMutation(UPDATE_PASSWORD, {
    onCompleted: () => {
      toast.success('Your password was sucessfully updated.');
      navigate('/login');
    },
    onError: ({ graphQLErrors }) => {
      graphQLErrors.forEach(({ message }) => {
        toast.error(message);
      });
    },
  });

  const handleUpdatePassword = async (values) => {
    await updatePassword({
      variables: values,
    });
  };
  return (
    <div className="bg-transparent">
      <div className="form-signin">
        <Card className="w-100">
          <CardBody>
            <div className="text-center">
              <h3>Update Password</h3>
            </div>
            <Formik
              initialValues={initialValues}
              onSubmit={handleUpdatePassword}
              validationSchema={validationSchema}
              children={(props) => <UpdatePasswordForm {...props} />}
            />
          </CardBody>
        </Card>
      </div>
    </div>
  );
};

export default UpdatePassword;
